import { Instagram, MessageCircle, MapPin, Phone } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brown-950 text-white">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16">
        <div className="max-w-7xl mx-auto">
          {/* Main footer */}
          <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            {/* Brand */}
            <div className="sm:col-span-2 lg:col-span-1">
              <h3 className="font-heading text-2xl font-bold text-white mb-4">
                Buteco do Baiano
              </h3>
              <p className="text-white/60 text-sm leading-relaxed max-w-xs">
                Bar e restaurante de comida baiana e culinária nordestina em Fortaleza, Ceará. Um pedacinho da Bahia na Varjota.
              </p>
              <div className="flex items-center gap-3 mt-6">
                <a
                  href="https://instagram.com/butecodobaianooficial"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram size={18} />
                </a>
                <a
                  href="https://wa.me/5585987413961?text=Olá!%20Vim%20pelo%20site%20do%20Buteco%20do%20Baiano%20e%20gostaria%20de%20mais%20informações."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors"
                  aria-label="WhatsApp"
                >
                  <MessageCircle size={18} />
                </a>
              </div>
            </div>

            {/* Navigation */}
            <div>
              <h4 className="font-heading text-sm font-bold text-white uppercase tracking-wider mb-4">
                Navegação
              </h4>
              <ul className="space-y-2.5">
                {[
                  { label: 'Início', href: '#inicio' },
                  { label: 'Sobre', href: '#sobre' },
                  { label: 'Sabores', href: '#sabores' },
                  { label: 'Ambiente', href: '#ambiente' },
                  { label: 'Galeria', href: '#galeria' },
                  { label: 'Localização', href: '#localizacao' },
                  { label: 'Contato', href: '#contato' },
                ].map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-white/60 text-sm hover:text-yellow-400 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Links úteis */}
            <div>
              <h4 className="font-heading text-sm font-bold text-white uppercase tracking-wider mb-4">
                Links Úteis
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <a
                    href="https://playmenu.app/public/index.php?r=buteco-do-baiano&from=admin"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/60 text-sm hover:text-yellow-400 transition-colors"
                  >
                    Cardápio digital
                  </a>
                </li>
                <li>
                  <a
                    href="https://instagram.com/butecodobaianooficial"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/60 text-sm hover:text-yellow-400 transition-colors"
                  >
                    Instagram
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.google.com/search?q=buteco+do+baiano+fortaleza"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/60 text-sm hover:text-yellow-400 transition-colors"
                  >
                    Google
                  </a>
                </li>
                <li>
                  <a
                    href="https://wa.me/5585987413961?text=Olá!%20Vim%20pelo%20site%20do%20Buteco%20do%20Baiano%20e%20gostaria%20de%20mais%20informações."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/60 text-sm hover:text-yellow-400 transition-colors"
                  >
                    WhatsApp
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-heading text-sm font-bold text-white uppercase tracking-wider mb-4">
                Contato
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <MapPin size={16} className="text-yellow-400 mt-0.5 flex-shrink-0" />
                  <span className="text-white/60 text-sm">
                    Rua 8 de Setembro, 1444 - Varjota<br />Fortaleza - CE, 60175-210
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <Phone size={16} className="text-yellow-400 flex-shrink-0" />
                  <a
                    href="tel:+5585987203361"
                    className="text-white/60 text-sm hover:text-yellow-400 transition-colors"
                  >
                    (85) 98720-3361
                  </a>
                </li>
                <li className="flex items-center gap-3">
                  <MessageCircle size={16} className="text-yellow-400 flex-shrink-0" />
                  <a
                    href="https://wa.me/5585987413961?text=Olá!%20Vim%20pelo%20site%20do%20Buteco%20do%20Baiano%20e%20gostaria%20de%20mais%20informações."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/60 text-sm hover:text-yellow-400 transition-colors"
                  >
                    WhatsApp
                  </a>
                </li>
                <li className="flex items-center gap-3">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-yellow-400 flex-shrink-0"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>
                  <span className="text-white/60 text-sm">
                    R$ 40-120 por pessoa
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="py-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-white/40 text-xs">
              &copy; {currentYear} Buteco do Baiano. Todos os direitos reservados.
            </p>
            <p className="text-white/40 text-xs">
              Fortaleza, Ceará
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}